import request, { BASE_URL } from './request'

export interface ReferralsPointsResponse {
  sum_points: number | null
}

export const getReferralsPoints = async (
  telegramId: string
): Promise<ReferralsPointsResponse> =>
  request({
    method: 'GET',
    url: `${BASE_URL}/customers/referrals_points/${telegramId}`,
  })
